var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"toast-fade"}},[(_vm.visible)?_c('div',{staticClass:"toast",class:_vm.type},[_c('span',{staticClass:"toast-icon"},[_vm._v(_vm._s(_vm.icon))]),_c('span',{staticClass:"toast-message"},[_vm._v(_vm._s(_vm.message))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }